import script from "./VensoDeliveryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoDeliveryItem.vue?vue&type=script&setup=true&lang=ts"

import "./VensoDeliveryItem.vue?vue&type=style&index=0&id=43c96e8f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c96e8f"]])

export default __exports__